export const formatInboxWaitDuration = (waitingSince, now, t) => {
  const minutes = Math.max(0, Math.floor((now / 1000 - waitingSince) / 60));
  if (!minutes) return t('INBOX_HIERARCHY.LESS_THAN_MINUTE');
  if (minutes < 60) return t('INBOX_HIERARCHY.MINUTES', { count: minutes });
  const hours = Math.floor(minutes / 60);
  if (hours < 24)
    return t('INBOX_HIERARCHY.HOURS_MINUTES', { hours, minutes: minutes % 60 });
  return t('INBOX_HIERARCHY.DAYS_HOURS', {
    days: Math.floor(hours / 24),
    hours: hours % 24,
  });
};
